import {
  FacebookIcon,
  InstagramIcon,
  TiktokIcon,
  TwitterIcon,
} from '@/components/icons'
import { Input } from '@/components/ui/input'
import { Control } from 'react-hook-form'
import { FormSchema } from '../sidebar-content'
import { FormField, FormLabel } from '@/components/ui/form'
import { useAuth } from '@/services/providers/auth-provider'

export function Contact({ control }: { control: Control<FormSchema> }) {
  const auth = useAuth()

  return (
    <>
      <FormField
        control={control}
        name="phone"
        render={({ field }) => (
          <>
            <FormLabel>Phone</FormLabel>
            <Input
              {...field}
              value={field.value ?? ''}
              placeholder="099-999-9999"
              type="tel"
              onChange={(e) => {
                const formattedValue = e.target.value
                  .replace(/\D/g, '') // Remove non-numeric characters
                  .replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3') // Format as xxx-xxx-xxxx
                  .slice(0, 12) // Limit to 12 characters (xxx-xxx-xxxx)

                field.onChange(formattedValue)
              }}
            />
          </>
        )}
      />

      <>
        <label>Email</label>
        <Input
          value={auth?.user?.email ?? ''}
          readOnly
          disabled
          className="bg-gray-200"
          placeholder="อีเมล"
        />
      </>

      <label>Social Media</label>

      <FormField
        control={control}
        name="SocialMedia.ig"
        render={({ field }) => (
          <div className="relative">
            <InstagramIcon className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 transform text-gray-500" />
            <Input
              {...field}
              className="w-full rounded-md border border-gray-300 py-2 pl-10 text-sm"
              value={field.value ?? ''}
              placeholder="username"
            />
          </div>
        )}
      />

      <FormField
        control={control}
        name="SocialMedia.facebook"
        render={({ field }) => (
          <div className="relative">
            <FacebookIcon className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 transform text-gray-500" />
            <Input
              {...field}
              className="w-full rounded-md border border-gray-300 py-2 pl-10 text-sm"
              value={field.value ?? ''}
              placeholder="username"
            />
          </div>
        )}
      />

      <FormField
        control={control}
        name="SocialMedia.tiktok"
        render={({ field }) => (
          <div className="relative">
            <TiktokIcon className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 transform text-gray-500" />
            <Input
              {...field}
              className="w-full rounded-md border border-gray-300 py-2 pl-10 text-sm"
              value={field.value ?? ''}
              placeholder="username"
            />
          </div>
        )}
      />

      <FormField
        control={control}
        name="SocialMedia.x"
        render={({ field }) => (
          <div className="relative">
            <TwitterIcon className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 transform text-gray-500" />
            <Input
              {...field}
              className="w-full rounded-md border border-gray-300 py-2 pl-10 text-sm"
              value={field.value ?? ''}
              placeholder="username"
            />
          </div>
        )}
      />
    </>
  )
}
